import httpClient from './Http'

export default {
	
	getLatLngForZipCode(zipCode){
		return httpClient.get(`/geo/lat-lon?zipCode=${zipCode}`);
	},

    getGeoLocationResponseForZipCode(zipCode){
        return httpClient.get(`/geo/location?zipCode=${zipCode}`);
    }
}


// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/GeoLocationService.js